export const REGISTER_FORM = {
  email: '邮箱',
  phone: '手机'
};

export const USER_STATUS = {
  '-1': { text: '冻结', color: 'info' },
  0: { text: '激活', color: 'success' }
};

export const BANK_AUTH_STATUS = {
  0: { text: '未绑定', color: 'info' },
  1: { text: '已绑定', color: 'success' }
};

export const ID_NO_STATUS = {
  '-1': { text: '黑名单', color: 'info' },
  0: { text: '未认证', color: 'info' },
  1: { text: '已认证', color: 'success' },
  2: { text: '审核中', color: 'warning' },
  3: { text: '认证失败', color: 'danger' }
};

export const EMAIL_SECURITY_STATUS = {
  0: { text: '未认证', color: 'info' },
  1: { text: '已认证', color: 'success' }
};

export const PHONE_SECURITY_STATUS = {
  0: { text: '未认证', color: 'info' },
  1: { text: '已认证', color: 'success' }
};

export const GOOGLE_SECURITY_STATUS = {
  0: { text: '未认证', color: 'info' },
  1: { text: '已认证', color: 'success' }
};

export const USER_VALUNTEER_STATUS = {
  0: { text: '否', color: 'info' },
  1: { text: '是', color: 'success' }
};

export const USER_BLOCKING_STATUS = {
  0: { text: '否', color: 'info' },
  '-1': { text: '是', color: 'danger' }
};

export const QUERY_TYPE = [
  { label: '用户ID', value: '0' },
  { label: '账号', value: '1' },
  { label: '身份证号', value: '2' },
  { label: '合伙人UID', value: '3' },
  { label: '推荐人UID', value: '4' },
];

export const PAGINATION = {
  page: 1,
  size: 25
};
